

export const decrpytData = (data) => atob(data);
export const decrpytDataToNum = (data) => Number(atob(data))
export const encrpytData = data => btoa(data)
export const encrpytNumData = data => btoa(data?.toString())